module.exports = __webpack_public_path__ + "media/images/client-8-60aa57d4f75f6caa9dea86987b4f31c0.png";